import { shopConstant } from '../constants';

export const generateLocationId = (
  districtCode: string,
  wardCode: string | null
) => {
  if (!wardCode) {
    return `${districtCode}00`;
  } else {
    return wardCode;
  }
};

const { POTENTIAL_TYPE } = shopConstant;

const formatValuesToCreateRequest = (
  newContract: boolean,
  values: any,
  fullAddress: { [k: string]: string }
) => {
  let params = { ...values };
  if (values.hasOwnProperty('type')) {
    if (values.type === '1') {
      params.type = 'Công ty';
      params.merchantName = values.merchantName
        ? values.merchantName.toUpperCase()
        : undefined;
    } else if (values.type === '2') {
      params.type = 'Hộ kinh doanh';
      params.merchantName = values.merchantName
        ? values.merchantName.toUpperCase()
        : undefined;
    } else if (values.type === '3') {
      params.type = 'Cá nhân';
      params.merchantName = `CN - ${values.representerName.toUpperCase()}`;
      params.representerNumberOfId = values.merchantCode;
    }
  }

  if (params.merchantCode) {
    params.merchantCode = values.merchantCode.toUpperCase();
  }

  params.contactName = values.representerName;
  params.merchantBrand = values.merchantBrand.toUpperCase();
  // params.appUser = values.contactPhone;

  if (values.hasOwnProperty('representerDob')) {
    params.representerDob = values.representerDob?.format('DD/MM/YYYY');
  }
  if (values.hasOwnProperty('representerDateOfIssue')) {
    params.representerDateOfIssue = values.representerDateOfIssue?.format(
      'DD/MM/YYYY'
    );
  }
  if (values.hasOwnProperty('passportExpiredAt')) {
    params.passportExpiredAt = values.passportExpiredAt?.format('DD/MM/YYYY');
  }
  if (values.hasOwnProperty('visaExpiredAt')) {
    params.visaExpiredAt = values.visaExpiredAt?.format('DD/MM/YYYY');
  }

  params.fullAddress = values.wardCode
    ? `${values.address}, ${fullAddress.ward}, ${fullAddress.district}, ${fullAddress.province}`
    : `${values.address}, ${fullAddress.district}, ${fullAddress.province}`;
  params.locationId = generateLocationId(values.districtCode, values.wardCode);
  delete params.wardCode;
  delete params.provinceCode;
  delete params.districtCode;

  params.potentialType = newContract
    ? POTENTIAL_TYPE.OFFICAL
    : POTENTIAL_TYPE.POTENTIAL;

  if (newContract) {
    params.isNotUsingVnpayWallet = false;
  }

  return params;
};

const formatValuesToUpdateRequest = (
  newContract: boolean,
  merchantDetail: any,
  values: any,
  fullAddress: { [k: string]: string }
) => {
  let params = { ...values, id: merchantDetail.id };
  if (values.hasOwnProperty('type')) {
    if (values.type === '1') {
      params.type = 'Công ty';
      params.merchantName = values.merchantName
        ? values.merchantName.toUpperCase()
        : undefined;
    } else if (values.type === '2') {
      params.type = 'Hộ kinh doanh';
      params.merchantName = values.merchantName
        ? values.merchantName.toUpperCase()
        : undefined;
    } else if (values.type === '3') {
      params.type = 'Cá nhân';
      params.representerNumberOfId = values.merchantCode;
      params.merchantName = `CN - ${values.representerName.toUpperCase()}`;
    }
  }
  if (params.merchantCode) {
    params.merchantCode = values.merchantCode.toUpperCase();
  }

  params.contactName = values.representerName;
  params.merchantBrand = values.merchantBrand.toUpperCase();
  // params.appUser = values.contactPhone;

  if (values.hasOwnProperty('representerDob')) {
    params.representerDob = values.representerDob?.format('DD/MM/YYYY');
  }
  if (values.hasOwnProperty('representerDateOfIssue')) {
    params.representerDateOfIssue = values.representerDateOfIssue?.format(
      'DD/MM/YYYY'
    );
  }
  if (values.hasOwnProperty('passportExpiredAt')) {
    params.passportExpiredAt = values.passportExpiredAt?.format('DD/MM/YYYY');
  }
  if (values.hasOwnProperty('visaExpiredAt')) {
    params.visaExpiredAt = values.visaExpiredAt?.format('DD/MM/YYYY');
  }

  params.fullAddress = values.wardCode
    ? `${values.address}, ${fullAddress.ward}, ${fullAddress.district}, ${fullAddress.province}`
    : `${values.address}, ${fullAddress.district}, ${fullAddress.province}`;
  params.locationId = generateLocationId(values.districtCode, values.wardCode);
  delete params.wardCode;
  delete params.provinceCode;
  delete params.districtCode;

  // if (merchantDetail.approvalStatus !== 'Khởi tạo') {
  //   delete params.type;
  //   delete params.merchantCode;
  //   if (params.hasOwnProperty('ewalletPhone')) {
  //     delete params.ewalletPhone;
  //   }
  // }
  params.potentialType =
    newContract && merchantDetail.potentialType !== POTENTIAL_TYPE.OFFICAL
      ? POTENTIAL_TYPE.OFFICAL
      : undefined;
  return params;
};

export default {
  formatValuesToCreateRequest,
  formatValuesToUpdateRequest,
};
